import {
  Box,
  Center,
  Grid,
  HStack,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import master from "../../img/mastercardlogo.svg";
import remita from "../../img/remitalogo.svg";
import verve from "../../img/vervelogo.svg";
import visa from "../../img/visalogo.svg";
import courseRoutes from "../../pages/courses/courseRoutes";
import routes from "../../pages/routes";

import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import registrationService from "../../services/registration.service";

const Footer = () => {
  const navigate = useNavigate();

  const handleDownload = async () => {
    try {
      registrationService.downloadTrainingCalendar().then((response) => {
        const imagefile = response.data;

        if (imagefile && imagefile.attachment) {
          fetch(imagefile.attachment)
            .then((response) => response.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;

              // Determine the file extension based on the MIME type
              const extension = blob.type.split("/")[1];
              const fileName = `${imagefile.calendar_name}.${extension}`;

              link.setAttribute("download", fileName); // Set the file name with extension
              document.body.appendChild(link);
              link.click();
              if (link.parentNode) {
                link.parentNode.removeChild(link);
              } else {
                document.body.removeChild(link); // Fallback if link.parentNode is null
              }
            })
            .catch((error) =>
              console.error("Error downloading the image:", error)
            );
        }
      });
    } catch (error) {
      console.error("Error fetching training calendar:", error);
    }
  };

  const quickLinks = [
    {
      text: "Register as a Trainee",
      href: routes.PreRegistration,
    },
    {
      text: "Register as a Trainer",
      href: routes.trainerPreReg,
    },
    {
      text: "Upcoming Trainings",
      href: routes.UpcomingTraining,
    },
    {
      text: "Programs & Courses",
      href: courseRoutes.AllCourses,
    },
    {
      text: "Locate a Training Centre",
      href: routes.TrainingCenters,
    },
    {
      text: "Track your Application",
      href: routes.TrackApplication,
    },
    {
      text: "Frequently Asked Questions",
      href: routes.FAQ,
    },
    {
      text: "Training Calendar",
      onClick: handleDownload,
    },
    {
      text: "General Announcements",
      href: routes.DashboardAnnouncements,
    },
    {
      text: "Contact Helpdesk",
      href: routes.HelpdeskNewRequest,
    },
  ];

  return (
    <>
      <Box
        bg="#2B2B2B"
        width={"100%"}
        height={"auto"}
        minHeight={"14rem"}
        pb={"1.2rem"}
        pt={"2.5rem"}
        display={"flex"}
        flexDirection={"column"}
        gap={"2rem"}
      >
        <Box
          width={["80%", "70%", "60%"]}
          display={"flex"}
          flexDirection={["column", "row"]}
          justifyContent={"space-between"}
          mx="auto"
        >
          <Grid
            gridTemplateColumns={["repeat(1,1fr)", "repeat(3,1fr)"]}
            columnGap={"2.6rem"}
            textAlign={["center", "left"]}
          >
            {quickLinks.map((link, index) => (
              <Link
                key={index}
                onClick={
                  link.onClick ? link.onClick : () => navigate(link.href)
                }
                color={"#FFFFFF"}
                fontSize={"14px"}
                mb={"1rem"}
                textDecoration={"none"}
              >
                {link.text}
              </Link>
            ))}
          </Grid>

          {/* social media links */}
          <VStack>
            <Text color={"#FFFFFF"} fontSize={"14px"} textAlign={"left"}>
              FOLLOW US ON
            </Text>
            <HStack>
              <a
                href="https://x.com/NAPTIN_Nigeria"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Center
                  width="40px"
                  bg="white"
                  borderRadius="20px"
                  height="40px"
                >
                  <FaTwitter color="black" fontSize="18px" />
                </Center>
              </a>

              <a
                href="https://www.instagram.com/naptin_nigeria/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Center
                  width="40px"
                  bg="white"
                  borderRadius="20px"
                  height="40px"
                >
                  <FaInstagram color="black" fontSize="18px" />
                </Center>
              </a>

              <a
                href="https://web.facebook.com/naptin24/?_rdc=1&_rdr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Center
                  width="40px"
                  bg="white"
                  borderRadius="20px"
                  height="40px"
                >
                  <FaFacebookF color="black" fontSize="18px" />
                </Center>
              </a>

              <a
                href="https://www.youtube.com/@naptinnigeria09"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Center
                  width="40px"
                  bg="white"
                  borderRadius="20px"
                  height="40px"
                >
                  <FaYoutube color="black" fontSize="18px" />
                </Center>
              </a>
            </HStack>
          </VStack>
        </Box>

        <HStack
          width={"100%"}
          gap={"1rem"}
          justifyContent={"center"}
          alignItems={"flex-end"}
        >
          <img src={remita} alt="payment option" />
          <img src={verve} alt="payment option" />
          <img src={master} alt="payment option" />
          <img src={visa} alt="payment option" />
        </HStack>
      </Box>
    </>
  );
};
export default Footer;
